
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import { Server, ServerState, Erg, ErgState, PreRace } from 'shared/state'

import Reconnect from './Reconnect.vue'
import Spinner from './Spinner.vue'
import Wait from './Wait.vue'
import isEmpty from 'lodash'

@Component({ components: { Reconnect, Spinner, Wait }})
export default class ServerConnect extends Vue {

	server = Server
	erg = Erg
	prerace = PreRace

	@Prop({ default: 'en-US' }) lang!: string

	@ServerState('state') serverState
	@ErgState() results

	@Watch('lang')
	languageChange(newLang: string) {
		Vue.loadLang(newLang)
	}

	@Watch('results', {immediate: true, deep: true})
	resultsChanged(newVal) {
	}

	connect() {
		Server.connect().then(() => this.$emit('ready'))
	}

	created() {
		Erg.attachToServer(Server)
		PreRace.attachToServer(Server)
		this.connect()
	}

}
